/* Rotates announcement messages every 4.5s with a fade. Static under prefers-reduced-motion; pauses on hover/focus. */
if (!customElements.get('bk-announcement')) {
  class BkAnnouncement extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.bk-announce__msg'));
      this.index = Math.max(0, this.messages.findIndex((m) => m.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 4500;
      this.paused = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('mouseenter', () => (this.paused = true));
      this.addEventListener('mouseleave', () => (this.paused = false));
      this.addEventListener('focusin', () => (this.paused = true));
      this.addEventListener('focusout', () => (this.paused = false));
      this.reduceMotion.addEventListener('change', () => this.start());
      this.onBlockSelect = (event) => {
        const i = this.messages.indexOf(event.target);
        if (i > -1) {
          this.show(i);
          this.stop();
        }
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      if (this.messages.length < 2 || this.reduceMotion.matches) return;
      this.timer = window.setInterval(() => {
        if (!this.paused) this.show((this.index + 1) % this.messages.length);
      }, this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    show(i) {
      this.messages.forEach((m, n) => m.classList.toggle('is-active', n === i));
      this.index = i;
    }
  }

  customElements.define('bk-announcement', BkAnnouncement);
}
